type GetDialRateToDisplayParams = {
  dialYear: number
  calculatedUtilityRate: number
  dialUtilityRates: number[]
}

export const getDialRateToDisplay = ({
  dialYear,
  calculatedUtilityRate,
  dialUtilityRates,
}: GetDialRateToDisplayParams): number => {
  if (dialYear === 1) {
    return calculatedUtilityRate
  }

  return dialUtilityRates[dialYear - 1] ?? 0
}
